import { Component } from '@angular/core';
import { ModalController, NavParams } from 'ionic-angular';

import { MenuService } from '../../../../providers/menu-service';

import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AlertService } from '../../../../providers/alert-service';
import { ConvenioService } from '../../../../providers/convenio-service';
import { ModalNaoSeAplicaPage } from "../../../modais/nao-se-aplica/modal-nao-se-aplica";

import { ModalPreVisualizarConveniosPage } from '../../../modais/modal-pre-visualizacao/convenios/modal-pv-convenios';

@Component({
  selector: 'page-resumo-analise',
  templateUrl: 'resumo-analise.html',
  providers: [
    ConvenioService
  ]
})
export class ConvenioResumoAnalisePage extends ModulosController {
  listaAnalises: any[];
  loading: boolean = true;
  tituloPagina: string = "";
  // isJurisdicionado: boolean;
  constructor(
    private convenioService: ConvenioService,
    public alertService: AlertService,
    public usuarioService: UsuarioService,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public gestaoPcaService: GestaoPcaService,
    public menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.carregarDados();
    this.setModuloId(6)
  }

  carregarDados() {

    // futura lista de analise dos analistas
    if (!this.isJurisdicionado) {
      this.convenioService.obterResumoAnalise().subscribe(data => {
        this.listaAnalises = data;

        this.listaAnalises.forEach(x => {
          if (x.idStatusAnalise == 5 || x.idStatusAnalise == 6 || x.idStatusAnalise == 7) {
            x.idStatusAnalise = 11;
            x.dsStatusAnalise = 'Para Consulta';
          }
        });

        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });
    } else {
      // Acesso aos jurisdicionados
      this.convenioService.obterListaAnalises(this.convenioService.codigoModuloConvenio).subscribe(data => {
        this.listaAnalises = data;

        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });
    }
    // this.loading = false;
  }

  redirecionarParaAnalise(analise) {
    analise.cdModulo = this.convenioService.obterIdPaginaConvenio();
    this.menuService.redirecionarSubPagina(this.convenioService.obterIdPaginaConvenio(), analise);
  }

  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';

    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }

  naoSeAplica(item) {

    this.gestaoPcaService.obterModuloPcaPorPCAPorModulo(this.gestaoPcaService.getPCA().id, 6).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloPca: data,
          IdProcesso: data.moduloPca,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'CONVENIOS',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  naoSeAplicaAnalise(item) {

    this.gestaoPcaService.obterModuloAnalise(item.idModuloAnalise).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloAnalise: data,
          IdProcesso: data.moduloAnalise,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'CONVENIOS',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  /*  previsualizarCertificado() {
 
     let modal = this.modalCtrl.create(ModalPreVisualizarConveniosPage, {});
     modal.onDidDismiss(retornoModal => {
       //retorno da modal
     });
     modal.present();
   } */

  previsualizarCertificado(dados) {
    let titulo = "Dados do Responsável";
    console.log(dados);
    let modal = this.modalCtrl.create(ModalPreVisualizarConveniosPage,
      {
        param1: titulo,
        dados: dados
      });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal && retornoModal.flag) {
        this.carregarDados();
      }
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/convenios/resumo-analise/resumo-analise.ts